import classNames from "classnames";
import * as React from "react";
import { $, merge } from "glamor";
import { VIEWPORT_MOBILE, VIEWPORT_PHABLET } from "constants/media";
import MoreIcon from "material-ui/svg-icons/navigation/more-horiz";
import { formatMessage } from "lib/globalize-util";
import MenuItem from "./menu-item";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                display: "block",
                marginTop: "8px",
            },
            $(".separatorTop", {
                borderTop: "1px solid rgba(255, 255, 255, .4)",
            }),
            $(".separatorBottom", {
                borderBottom: "1px solid rgba(255, 255, 255, .4)",
            }),
            $(".expand", {
                flex: 1,
            }),
            $(" .navBarLink", {
                marginBottom: "8px",
            }),
        );
    }
    return styles;
};

const preventDefault = (e) => e.preventDefault();

export const Section = ({
    separatorTop = false,
    separatorBottom = false,
    children,
    expand = false,
    viewportHeight = 1,
    viewport,
}) => {
    const visibileChildren = [];
    const extraChildren = [];
    const isDesktop = viewport !== VIEWPORT_MOBILE && viewport !== VIEWPORT_PHABLET;
    React.Children.forEach(children, (child: React.ReactElement<any>, i) => {
        if (child) {
            // If we are over viewport height, store it here. Icon height is 44px
            if (isDesktop && (visibileChildren.length + 6) * 44 > viewportHeight) {
                extraChildren.push(
                    React.cloneElement(child, {
                        Icon: undefined,
                        key: i,
                    }),
                );
            } else {
                visibileChildren.push(
                    React.cloneElement(child, {
                        className: classNames("navBarLink", (child as any).className),
                        key: i,
                    }),
                );
            }
        }
    });
    return (
        <div {...getStyles()} className={classNames({ separatorTop, separatorBottom, expand })}>
            {visibileChildren}
            {!!extraChildren.length && (
                <MenuItem Icon={MoreIcon} label={formatMessage("More")} onClick={preventDefault}>
                    {extraChildren}
                </MenuItem>
            )}
        </div>
    );
};
